import { useMutation } from '@tanstack/react-query';
import { useOrg } from 'src/shared/contexts/OrgContext';

type CreateTestItemParams = {
  integrationId: string;
  threadId: string;
  modelId: string;
  correctPrediction: Record<string, unknown>;
};

type CreateTestItemResponse = {
  id: string;
  extractionModelId: string;
  integrationId: string | null;
  threadId: string | null;
  messageId: string | null;
  messageObject: unknown | null;
  contentRaw: string | null;
  correctPrediction: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
};

export function useCreateTestItem() {
  const { orgFetch } = useOrg();

  return useMutation({
    mutationFn: async (params: CreateTestItemParams): Promise<CreateTestItemResponse> => {
      const res = await orgFetch<CreateTestItemResponse>('/api/v2/next-gen-models/extraction/test-items', {
        method: 'POST',
        body: JSON.stringify({
          integrationId: params.integrationId,
          threadId: params.threadId,
          modelId: params.modelId,
          correctPrediction: params.correctPrediction,
        }),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error((errorData as { message?: string })?.message || 'Failed to create test item');
      }

      return res.json();
    },
  });
}
